import InputWithMask from "./InputWithMask";
import CheckBox from "./Checkbox";
import Input from "./Input";
import Radios from "./Radios";
import InputHidden from "./InputHidden";
import Selects from "./Selects";

export default class Form {
    /**
     * @type {HTMLFormElement}
     */
    formElement;

    fields = [];

    /**
     * @type {Map<'submit'|'change'>, []>}
     */
    listeners;


    changeTimeout;

    /**
     * @param {HTMLFormElement} element 
     */
    constructor(element) {
        
        if (!element) {
            return;
        }

        this.formElement = element;
        this.formElement.setAttribute('novalidate', true);
        this.initFields();
        this.addListeners();
        

        this.listeners = new Map();
    }

    initFields() {
        /**
         * TODO: 
         * Добавить сюда селекты 
         */


        const inputs = Array.from(this.formElement.querySelectorAll('.form-input'));
        const checkboxes = Array.from(this.formElement.querySelectorAll('.form-checkbox'));
        const radioGroups = Array.from(this.formElement.querySelectorAll('.radio-group'));
        const hidden = Array.from(this.formElement.querySelectorAll('input[type="hidden"]'));
        const selects = Array.from(this.formElement.querySelectorAll('.select-component'));
        [...inputs, ...checkboxes, ...radioGroups, ...selects, ...hidden].forEach(el => {

            if (el.formInited) {
                return;
            }

            let inputEl = el.type && el.type === 'hidden' ? el : el.querySelector('input');

            if (!inputEl) {
                inputEl = el.querySelector('select');
            }

            if (!inputEl) {
                return;
            }

            let { type } = inputEl;

            if (inputEl.tagName.toLowerCase() === 'select') {
                type = 'select';
            }

            el.formInited = true;
            
            switch(type) {
                case 'checkbox':
                    this.fields.push(new CheckBox(el, this));
                    break;
                case 'radio':
                    this.fields.push(new Radios(el, this));
                    break;
                case 'tel':
                    this.fields.push(new InputWithMask(el, this));
                    break;
                case 'hidden':
                    this.fields.push(new InputHidden(el, this));
                    break;
                case 'select':
                    this.fields.push(new Selects(el, this));
                    break;
                default: 
                    this.fields.push(new Input(el, this));
                    break;
            }
            
        });
    }

    addListeners() {
        this.formElement.addEventListener('submit', (e) => {
            e.preventDefault();
            this.submit();
        });

        this.formElement.addEventListener('reset', () => {
            this.fields.forEach(field => field.reset());
        });
    }

    submit() {
        if (!this.validate()) {
            console.warn('invalid form');
            return;
        }

        this.process();
    }

    validate() {
        const results = [];

        this.fields.forEach(input => {
            results.push(input.validate());
        });

        return results.every(r => r === true);
    }

    process() {
        const data = this.collectValues();

        if (this.listeners.has('submit')) {
            const callbacks = this.listeners.get('submit');
            Object.values(callbacks).forEach(callback => {
                callback(data);
            });
        }
    }

    collectValues() {
        const values = {};

        this.fields.forEach(field => {
            if (Object.keys(values).includes(field.name)) {
                
                if (Array.isArray(values[field.name])) {
                    values[field.name].push(field.value);
                } else {
                    values[field.name] = [values[field.name], field.value];
                }

                values[field.name] = values[field.name].filter(val => !!val);

                return;
            }

            values[field.name] = field.value;
        });

        return values;
    }

    on(eventName, handler) {
        if (!this.formElement) {
            return;
        }

        this.listeners.has(eventName) || this.listeners.set(eventName, []);
        this.listeners.get(eventName).push(handler);
    }

    onChange() {
        if (this.changeTimeout) {
            clearTimeout(this.changeTimeout);
        }

        this.changeTimeout = setTimeout(() => {
            const data = this.collectValues();

            if (this.listeners.has('change')) {
                const callbacks = this.listeners.get('change');
                Object.values(callbacks).forEach(callback => {
                    callback(data);
                });
            }
        }, 30);
        
    }

    reset() {
        if (!this.formElement) {
            return;
        }

        this.formElement.reset();
    }
}
